<app-modal *ngIf="!loading"
      appScopedDragDrop
      (filesDropped)="onFilesDropped($event)"
      (dragStateChanged)="onDragStateChanged($event)"
      class="scoped-drag-drop-container">
  <app-loading *ngIf="loading"></app-loading>
  <ng-container *ngIf="!loading"></ng-container>
  <app-modal-header
    [title]="currentDetailsItem.title"
    [editableTitle]="userHasWriteAccess && !currentDetailsItem.archived"
    [hideCloseBtn]="true"
    (titleUpdate)="onTitleUpdate($event)"
  ></app-modal-header>
  <app-modal-body>
    <section class="row custom-gutters section-padding pt-0">
      <div class="header-info col-12 mb-3">
        <div class="creator-info">
          <i class="material-symbols-outlined">receipt</i>
          <span class="fw-bold">{{createdByName}}</span>
          <span style="color: var(--wt-grey-dark);">&nbsp;at&nbsp;</span>
          <span class="fw-bold">{{currentDetailsItem.created | localisedDate: true : true}}</span>
        </div>
        <div class="more-info-and-actions">
          <div class="details-label me-2">{{ T.common.id_in_header | translate: { id: currentDetailsItem.id } }} </div>
          <div class="d-flex align-items-center">
            <div class="created-badge">
              {{currentDetailsItem.created | lastUpdatedDate}}
            </div>
            <app-button-icon-square
              [icon]="'more_horiz'"
              [size]="isMobile ? 'large' : 'small'"
              ngDropdown
              [templateRef]="moreButtonTemplate"
            ></app-button-icon-square>
          </div>
        </div>
      </div>
      <div class="d-flex col-12">
        <app-details-text-area
          class="w-100"
          [input]="currentDetailsItem.description ? currentDetailsItem.description : ''"
          [label]="T.defaultLocalizations.description.one | translate"
          [placeholder]="T.common.add_description | translate"
          [canEdit]="userHasWriteAccess && !currentDetailsItem.archived"
          (update)="updateDescription($event)"
        ></app-details-text-area>
      </div>
      <div class="col-12 col-lg-6 mb-2">
         <div class="col-5 details-label pe-0">
        {{ T.common.category.one | translate }}
        </div>
        <div class="col-7 details-value">
          <app-details-lozenge
            [filters]="currentDetailsItem.filters"
            [filterType]="filterTypes.Incident_Category"
            [canEdit]="userHasWriteAccess && !currentDetailsItem.archived"
            class="w-100"
            [accordionLozenge]="true"
            [clearPaddingInLozenge]="true"
            [useLightUpdate]="true"
            (onFiltersUpdated)="onFiltersUpdated($event)"
          ></app-details-lozenge>
        </div>
      </div>
      <div class="col-12 col-lg-6 mb-2">
        <div class="col-5 details-label pe-0">
        {{ filterTypes.Department | localiseFilterType: true }}
        </div>
        <div class="col-7 details-value">
          <app-details-lozenge
            class="w-100"
            [filters]="currentDetailsItem.filters"
            [filterType]="filterTypes.Department"
            [canEdit]="userHasWriteAccess && !currentDetailsItem.archived"
            [useLightUpdate]="true"
            [clearPaddingInLozenge]="true"
            (onFiltersUpdated)="onFiltersUpdated($event)"
            [accordionLozenge]="true"
          ></app-details-lozenge>
        </div>
      </div>
      <div class="col-12 col-lg-6 mb-2">
        <div class="col-5 details-label pe-0">{{ filterTypes.Owner | localiseFilterType: true }}</div>
        <div class="col-7 details-value">
          <app-details-lozenge
            class="w-100"
            [filters]="currentDetailsItem.filters"
            [filterType]="filterTypes.Owner"
            [canEdit]="userHasWriteAccess && !currentDetailsItem.archived"
            [accordionLozenge]="true"
            [useLightUpdate]="true"
            [clearPaddingInLozenge]="true"
            (onFiltersUpdated)="onFiltersUpdated($event)"
            ></app-details-lozenge>
          </div>
        </div>
      <div class="col-12 col-lg-6 mb-2">
        <div class="col-5 details-label pe-0">
          {{ filterTypes.Privacy_Status | localiseFilterType }}
        </div>
        <div class="col-7 details-value">
          <app-details-lozenge
            class="w-100"
            [filters]="currentDetailsItem.filters"
            [filterType]="filterTypes.Privacy_Status"
            [canEdit]="userHasWriteAccess && !currentDetailsItem.archived"
            [singleSelect]="true"
            [accordionLozenge]="true"
            [isFilterRequired]="true"
            [useClearAllButton]="false"
            [clearPaddingInLozenge]="true"
            (onFiltersUpdated)="onFiltersUpdated($event)"
          ></app-details-lozenge>
        </div>
      </div>

      <!-- Accordion details -->
      <div class="details-accordion">
      <app-accordion-details [collapsing]="false" (onItemIndexClicked)="onItemIndexClicked($event)">
        <app-accordion-item-details [title]="T.hub.simple_modals_accordeon | translate" [expanded]="false">
          <ng-template accordionContent>
            <div class="additional-details row mb-2">
              <div class="col-12 col-lg-6 mb-2">
                <div class="col-5 details-label pe-0">
                  {{ objectTypes.User_Group | localiseObjectType: true }}
                </div>
                <div class="col-7 details-value">
                  <app-details-lozenge
                    class="w-100"
                    [accordionLozenge]="true"
                    [filters]="currentDetailsItem.filters"
                    [filterType]="filterTypes.User_Group"
                    [canEdit]="userHasWriteAccess && !currentDetailsItem.archived"
                    [useLightUpdate]="true"
                    [clearPaddingInLozenge]="true"
                    (onFiltersUpdated)="onFiltersUpdated($event)"
                  ></app-details-lozenge>
                </div>
              </div>
              <div class="col-12 col-lg-6 mb-2">
                <div class="col-5 details-label pe-0">
                  {{ objectTypes.Event | localiseObjectType }}
                </div>
                <div class="col-7 details-value">
                  <app-details-lozenge
                    class="w-100"
                    [accordionLozenge]="true"
                    [filters]="currentDetailsItem.filters"
                    [filterType]="filterTypes.Event"
                    [canEdit]="userHasWriteAccess && !currentDetailsItem.archived"
                    [singleSelect]="true"
                    [useLightUpdate]="true"
                    [clearPaddingInLozenge]="true"
                    (onFiltersUpdated)="onFiltersUpdated($event)"
                  >
                  </app-details-lozenge>
                </div>
              </div>
              <div class="col-12 col-lg-6 mb-2">
                  <div class="col-5 details-label pe-0">{{ T.calendar.starts | translate }}</div>
                  <div class="col-7 details-value">
                    <app-details-datepicker
                      [range]="true"
                      [timePicker]="true"
                      [includeTime]="true"
                      [canEdit]="userHasWriteAccess && !currentDetailsItem.archived"
                      [date]="currentDetailsItem.startTime"
                      [endDate]="currentDetailsItem.endTime"
                      [maxDate]="currentDetailsItem.endTime"
                      [accordionLozenge]="true"
                      [label]="T.calendar.start | translate"
                      [clearPaddingInLozenge]="true"
                      (dateChanged)="onStartDateChanged($event)"
                      (datesChanged)="onDatesChanged($event)"
                    >
                    </app-details-datepicker>
                  </div>
              </div>
              <div class="col-12 col-lg-6 mb-2">
                <div class="col-5 details-label pe-0">{{ T.lozenges_label.date_related.due | translate }}</div>
                <div class="col-7 details-value">
                  <app-details-datepicker
                    [range]="true"
                    [timePicker]="true"
                    [includeTime]="true"
                    [canEdit]="userHasWriteAccess && !currentDetailsItem.archived"
                    [date]="this.currentDetailsItem.endTime"
                    [startDate]="this.currentDetailsItem.startTime"
                    [endDate]="this.currentDetailsItem.endTime"
                    [minDate]="this.currentDetailsItem.startTime"
                    [label]="T.defaultLocalizations.end_time.one | translate"
                    [accordionLozenge]="true"
                    [clearPaddingInLozenge]="true"
                    (dateChanged)="onEndDateChanged($event)"
                    (datesChanged)="onDatesChanged($event)">
                  </app-details-datepicker>
                </div>
              </div>

              <app-details-tags
                class="w-100"
                [accordionTagTitleClass]="'col-5'"
                [accordionTagValueClass]="'col-7'"
                [canEdit]="userHasWriteAccess && !currentDetailsItem.archived"
                [accordionLozenge]="true"
                [filters]="currentDetailsItem.filters"
                [tagGroupObjectType]="objectType"
                [useLightUpdate]="true"
                [showAsColumns]="true"
                [clearPaddingInLozenge]="true"
                (onFiltersUpdated)="onFiltersUpdated($event)"
              ></app-details-tags>
            </div>
          </ng-template>
        </app-accordion-item-details>
        <app-accordion-item-details>
          <ng-template accordionTitle>
            <app-accordion-title-with-counter
              [title]="T.common.location.one | translate"
              [count]="locationFieldsCount">
            </app-accordion-title-with-counter>
          </ng-template>
          <ng-template accordionContent>
            <div *ngIf="locationContainerDirty" class="location-container mb-3">
              <app-location-details
                [objectId]="currentDetailsItem.id"
                [filters]="currentDetailsItem.filters"
                [lat]="currentDetailsItem.latitude"
                [lng]="currentDetailsItem.longitude"
                [markerType]="markerType"
                [markerColor]="markerColor"
                [displayFiltersAsLozenges]="false">
              </app-location-details>
              <div class="mt-3 mb-3" *ngIf="isAdmin">
                <app-button-rectangle
                  [text]="T.common.edit_location | translate"
                  icon="edit"
                  buttonTheme="white"
                  [disabled]="false"
                  (clicked)="openLocationEditModal()"
                ></app-button-rectangle>
              </div>
            </div>
          </ng-template>
        </app-accordion-item-details>
        <app-accordion-item-details>
          <ng-template accordionTitle>
            <app-accordion-title-with-counter
              [title]="T.common.linked_item.many | translate"
              [count]="linkedItemsCount">
            </app-accordion-title-with-counter>
          </ng-template>
          <ng-template accordionContent>
            <div>
              <app-linked-items-accordion-list
                (linkedItemsCount)="linkedItemsCount = $event"
                [canAddLinkedItems]="userHasWriteAccess && !currentDetailsItem.archived"
                [id]="currentDetailsItem.id"
                [title]="currentDetailsItem.title"
                [objectType]="objectTypes.IncidentItem"
              ></app-linked-items-accordion-list>
            </div>
          </ng-template>
        </app-accordion-item-details>
        <app-accordion-item-details [title]="T.common.history | translate" [expanded]="false">
          <ng-template accordionContent>
            <div *ngIf="historyExpanded" class="history-feed-wrapper mb-3">
              <app-history-feed-new
              *ngIf="historyExpanded"
              [canEdit]="userHasWriteAccess && !currentDetailsItem.archived"
              [showInput]="true"
              [objectId]="currentDetailsItem.id"
              [objectType]="objectType"
              [showHeader]="false"
              [singleItemHistory]="true"
              (historyEntriesCount)="onHistoryEntriesUpdate($event)"
            ></app-history-feed-new>
            </div>
          </ng-template>
        </app-accordion-item-details>
        <app-accordion-item-details [expanded]="selectedAccordionItemId === 'attachments'">
          <ng-template accordionTitle>
            <app-accordion-title-with-counter
              [title]="T.common.attachment.many | translate"
              [count]="attachmentsCount">
            </app-accordion-title-with-counter>
          </ng-template>
          <ng-template accordionContent>
            <div class="details-container">
              <app-document-manager-general-settings
                (documentsChanged)="onDocumentsChanged($event)"
                [objectId]="currentDetailsItem?.id"
                [objectType]="objectType"
                [object]="currentDetailsItem"
                [filterType]="filterTypes.Job"
                [isInAccordion]="true"
                [isDetailsPage]="true"
                [showListBoardButtons]="false"
                [disableDragAndDrop]="true">
              </app-document-manager-general-settings>
            </div>
          </ng-template>
        </app-accordion-item-details>
      </app-accordion-details>
    </div>
    </section>
  </app-modal-body>
  <app-modal-footer class="d-flex align-items-end">
    <app-button-rectangle [size]="'large'"  [text]="T.common.close | translate" (clicked)="onClose()"></app-button-rectangle>
  </app-modal-footer>
</app-modal>

<ng-template #moreButtonTemplate>
  <div class="dropdown-options-container">
    <div *ngIf="!currentDetailsItem.archived" (click)="openItemHistoryFeedDrawer()" class="dropdown-option">{{ addCommentText }}</div>
    <div *ngIf="!currentDetailsItem.archived && userHasWriteAccess" (click)="onMakeIncident()" class="dropdown-option">
      {{ T.control.escalate_log_to_incident | translate }}
    </div>
    <div *ngIf="!currentDetailsItem.archived" (click)="onArchiveIncident(true)" class="dropdown-option">
      {{ archiveText }}
    </div>
    <div *ngIf="currentDetailsItem.archived" (click)="onArchiveIncident(false)" class="dropdown-option">
      {{ unarchiveText }}
    </div>
  </div>
</ng-template>
